const occasionCards = document.querySelectorAll('.occasion-card-list .occasion-card');

occasionCards.forEach((card) => {
  const video = card.querySelector('video');
  if (!video) return;
  const image = card.querySelector('.occasion-card__image--default');

  video.muted = true;

  video.addEventListener('loadeddata', () => {
    video
      .play()
      .then(() => {
        setTimeout(() => {
          video.pause();
        }, 100);
      })
      .catch(() => {});
  });

  card.addEventListener('mouseenter', () => {
    video.play();
    image.style.opacity = 0;
  });

  card.addEventListener('mouseleave', () => {
    video.pause();
    image.style.opacity = 1;
  });
});
